export const mutationTypes = {
  setPageIndex: '[archive] setPageIndex',
  setPageSize: '[archive] setPageSize',
  getRespondentReportsRequest: '[archive] getRespondentReportsRequest',
  getRespondentReportsSuccess: '[archive] getRespondentReportsSuccess',
  getRespondentReportsFailure: '[archive] getRespondentReportsFailure'
}

export const actionTypes = {
  getRespondentReports: '[archive] getRespondentReports'
}



// WEBPACK FOOTER //
// ./src/store/modules/archive/types.js